import React, { useState, useEffect } from 'react';

const RegisterAsFarm = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  useEffect(() => {
    if (imageLoaded) {
      document.body.classList.add("loaded");
    }
  }, [imageLoaded]);

  return (
    <div className="md:px-24 px-4 md:mb-20 mb-10 mt-10 md:mt-20">
      
      {/* Icon with fade-in + scale effect */}
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745858904/Expand_left_dshlo0.png"
        alt="Expand Icon"
        onLoad={handleImageLoad}
        className={`md:w-6 md:h-6 w-3 h-3 mb-6 transition-transform duration-1000 ease-in-out ${imageLoaded ? 'scale-100 opacity-100' : 'scale-110 opacity-0'}`}
      />

      {/* Heading with fade-in effect */}
      <h1 className="text-[36px] font-bold text-[#03897B] mb-3 transition-opacity duration-1000 ease-in-out opacity-0 loaded:opacity-100">
        WHY REGISTER AS A FARMER
      </h1>

      {/* Paragraphs with fade-in effect */}
      <div className="text-[24px] font-normal text-black leading-relaxed transition-opacity duration-1000 ease-in-out opacity-0 loaded:opacity-100">
        <p className="mb-6">
          <strong>Access to Support Services:</strong> Registration allows farmers to receive support in managing their farms. This includes technical assistance, advice on best practices, and access to government programs aimed at boosting productivity and profitability.
        </p>
        <p className="mb-6">
          <strong>Resources and Grants:</strong> Registered farmers may be eligible for access to various resources such as seeds, equipment, and financial grants. These resources are often provided by government initiatives or development partners to help farmers grow and improve their businesses.
        </p>
        <p className="mb-6">
          <strong>Link to Verified Service Providers:</strong> Being a registered farmer gives you access to a network of verified service providers. This network can include suppliers, agronomists, veterinarians, and other experts who can provide quality services tailored to your specific needs.
        </p>
        <p className="mb-6">
          <strong>Partnerships with Development Organizations:</strong> Registration can connect farmers to development partners, NGOs, and international agencies that support agricultural development. These partnerships may open doors to collaborative projects, funding opportunities, and skill-building programs.
        </p>
        <p className="mb-6">
          <strong>Market Access:</strong> Farmers who are officially registered have better access to both local and international markets. Registration can provide opportunities to sell products to established buyers, cooperatives, or even government procurement programs, ensuring fair pricing and reliable sales channels.
        </p>
      </div>

      {/* Spacer */}
      <div className="md:h-80 h-40"></div>
    </div>
  );
};

export default RegisterAsFarm;
